import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=e1b99c12&scoped=true"
var script = {}
import style0 from "./Page.vue?vue&type=style&index=0&id=e1b99c12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b99c12",
  null
  
)

export default component.exports